import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { TestStrategy } from 'modules/experiments/types';
import { WinningCriteriaTestDurationSettings } from './WinningCriteriaTestDurationSettings';
import {
  ReadOnlySettingsWrapper,
  StyledSettingsFieldValue,
  StyledSettingsFormField,
} from './Styled';

export const TriggerSettings = () => {
  const { t } = useExperimentsTranslations();
  const {
    triggerCampaignMetaInfo: { testStrategy, testSendsPerVariation },
  } = useTakeoverExperimentContext();

  return (
    <>
      <ReadOnlySettingsWrapper data-test="trigger-read-only-settings">
        <StyledSettingsFormField
          labelText={t('settings.audienceSettings.testStrategy')}
          isHorizontalLayout
        >
          <StyledSettingsFieldValue>
            {testStrategy === TestStrategy.SUBSET_USERS
              ? t('settings.audienceSettings.testSubsetOfUsers')
              : t('settings.audienceSettings.testAllUsers')}
          </StyledSettingsFieldValue>
        </StyledSettingsFormField>
        {testStrategy === TestStrategy.SUBSET_USERS && (
          <StyledSettingsFormField
            labelText={t('settings.minSendsPerVariant.label')}
            isHorizontalLayout
          >
            <StyledSettingsFieldValue>{testSendsPerVariation}</StyledSettingsFieldValue>
          </StyledSettingsFormField>
        )}
      </ReadOnlySettingsWrapper>
      <WinningCriteriaTestDurationSettings />
    </>
  );
};
